import type { SystemDocumentEntry } from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'

export function allDocumentsHaveRevisionCodes(
  documents: SystemDocumentEntry[]
): boolean {
  return documents.every(
    (doc) =>
      doc.entry.data.revision_code !== undefined &&
      doc.entry.data.revision_code !== null &&
      doc.entry.data.revision_code !== ''
  )
}

/**
 * Compares two revision codes in ascending order.
 * Letters sort before numbers (A, B, C, 0, 1, 2, 3).
 * Letters are compared alphabetically; numbers are compared numerically.
 */
export function compareRevisionCodes(revA: string, revB: string): number {
  const isANumber = /^\d+$/.test(revA)
  const isBNumber = /^\d+$/.test(revB)

  if (isANumber !== isBNumber) return isANumber ? 1 : -1

  return isANumber ? parseInt(revA) - parseInt(revB) : revA.localeCompare(revB)
}

export function getLatestDocumentByRevision(
  documents: SystemDocumentEntry[]
): SystemDocumentEntry | undefined {
  if (documents.length === 0) return undefined
  const sortedByRevision = [...documents].sort((a, b) => {
    const revA = a.entry.data.revision_code ?? ''
    const revB = b.entry.data.revision_code ?? ''
    return -compareRevisionCodes(revA, revB)
  })
  return sortedByRevision[0]
}
